import styled, { keyframes } from "styled-components";

// Define the animation for the dots
const bounce = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
`;

// Style for each dot
const Dot = styled.div`
  width: 10px;
  height: 10px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
  margin: 0 5px;
  animation: ${bounce} 0.6s infinite ease-in-out;

  &:nth-child(2) {
    animation-delay: 0.2s;
  }

  &:nth-child(3) {
    animation-delay: 0.4s;
  }
`;

// Style for the loader container
export const LoaderWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Loader = () => {
  return (
    <LoaderWrapper>
      <Dot />
      <Dot />
      <Dot />
    </LoaderWrapper>
  );
};

export default Loader;
